import React, { useContext, useEffect } from 'react'
import { DataContext } from '../../../context/DataContext'
import { Components, GeneralModules, RiskManagementModules } from '../../../api/schemas/schema'
import { useNavigate } from 'react-router-dom'
import { useHasModule } from '../../../helpers/useHasModule'

type ModuleGuardProps = {
   children: React.ReactNode
   allowedModules: (GeneralModules | RiskManagementModules | Components)[]
}
export const ModuleGuard = ({ allowedModules, children }: ModuleGuardProps) => {
   const { checkAccess } = useHasModule()
   const isAllowed = checkAccess(allowedModules)

   return isAllowed ? <>{children}</> : null
}

type ModuleRouteGuardProps = {
   children: React.ReactNode
   allowedModules: (GeneralModules | RiskManagementModules | Components)[]
   navigateTo?: string
}
export const ModuleRouteGuard = ({ allowedModules, children, navigateTo }: ModuleRouteGuardProps) => {
   const navigate = useNavigate()
   const dataContext = useContext(DataContext)
   const { organisation } = dataContext.state

   const { checkAccess } = useHasModule()

   const isAllowed = checkAccess(allowedModules)

   useEffect(() => {
      if (organisation?.id && organisation?.modules && !isAllowed) {
         navigate(navigateTo ? navigateTo : '/')
      }
   }, [isAllowed, navigate, navigateTo, organisation])

   return isAllowed ? <>{children}</> : null
}
